import { isBefore, subDays } from 'date-fns';

export const isAutosaveStale = (
  timestamp: string | undefined,
  maxAgeDays: number,
): boolean =>
  Boolean(
    timestamp && isBefore(new Date(timestamp), subDays(new Date(), maxAgeDays)),
  );
